import { Container } from "@chakra-ui/react";
import React from "react";
import Education from "./Education";
import Head from "./Head";
const About = () => {
  const edu = [
    {
      insName: "BGC Trust University Bangladesh",
      title: "B.Sc (Hon's) in Computer Science and Engineering(CSE)",
      grade: "4 years to complete, CGPA was 3.86 out of 4.00",
      duration: "2018-2021",
    },
    {
      insName: "BAF Shaheen College, Chittagong. Bangladesh",
      title: "HSC",
      grade:
        "Needed to complete 2 years. Studied Science group. Activities and Societies: Bangladesh National Cadet Corps(BNCC).Science fair project Presentation,Math olympiad.",
      duration: "2016-2017",
    },
  ];
  const courses = [
    {
      insName: "Learning & Earning Development Project - LEDP ",
      title: "LEDP (SEO)",
      grade: ".3 months course search engine optimization(SEO) ",
      duration: "2020",
    },
    {
      insName: "coursera.org",
      title: "Blockchain Basics",
      grade:
        "A learner will be able to recognize foundational concepts of blockchain, and apply these program concepts on the blockchain",
      duration: "2021",
    },
    {
      insName: "coursera.org",
      title: "Modern JavaScript: ES6 Basics",
      grade: "Computer Programming, ES6, JavaScript, Front-end web",
      duration: "October 18, 2020 2 hours",
    },
    {
      insName: "coursera.org",
      title: "Front-End Web Development with React",
      grade:
        "Online Course on udemy.com covered A to Z of Gnu Linux Operating system. that's how i have mastered Linux.",
      duration: "October 27, 2020, 4 weeks of study, 6-8 hours/week",
    },
    {
      insName: "Programming-Hero.com",
      title: "Complete Web Development",
      grade:
        "Online course covered a to z of web devolopment with reactjs, nodejs, expressjs, mongodb,firebase, sass,bootstrap, tailwind css. i have completed this course and got certified.",
      duration: "2022",
    },
    {
      insName: "Team Matrix",
      title: "Ethical Hacking",
      grade: "Ethical hacker",
      duration: "2021",
    },
    {
      insName: "Hardware and Networking.",
      title:
        "Hardware and Networking Course From Computer Village, Agrabad, Chattogram",
      grade: "A+",
      duration: "2018",
    },
  ];
  const exp = [
    {
      insName: "Mass Group BD, Chittagong.",
      title: "Jr. Programmer",
      grade: "Joined as a Junior Programmer - Full Time",
      duration: "Aug, 2022 - Present",
    },
    {
      insName: "HELPY_MOTO. Delhi,India",
      title: "Mobile Application Development(Intern)",
      grade: "Here I joined as a Mobile Application Developer Intern.",
      duration: "June, 2022 - July, 2022",
    },
    {
      insName: "YouTube Content Creator",
      title: "Tutorials",
      grade:
        "Training and giving lectures on Programming, focusing Based on Computer Science and Engineering Student.",
      duration: "March, 2020 - Present",
    },
  ];
  const awards = [
    {
      insName: "PROGRAMMING CONTEST",
      title: "Intra Programming Contest: - BGC Trust University Bangladesh.",
      grade: "Intra Programming Contest: 2018; 2019; 2020 & 2021",
      duration: "2018; 2019; 2020 & 2021",
    },
    {
      insName: "CUET CSE FEST",
      title: "Programming Contest",
      grade: "Team name: - BGC-Polymorphism and Zero-to-Infinity",
      duration: " 2018 & 2019.",
    },
    {
      insName: "IUT 10th ICT FEST2019",
      title: "Programming Contest",
      grade: "Team name: - Zero-to-Infinity",
      duration: "2019",
    },
    {
      insName: "RMSTU-BDPC - 2021",
      title: "Contest(Online)",
      grade: "Team name : - Three Dots",
      duration: "2021",
    },
    {
      insName: "Mathematics Olympiad",
      title: "National Undergraduate Mathematics Olympiad",
      grade:
        "Greater Chattogram Region, Hosted and organized by Department Of Mathematics, Premier University.",
      duration: "2019 & 2021",
    },
    {
      insName: "Intra Software Exhibition Competition 2021",
      title: "Software Exhibition Competition 2021",
      grade:
        "I have won the first position by attending the  Winter School 2021 software exhibition competition organized by BGCTUB.",
      duration: "2021",
    },
    {
      insName: "Research Paper Accepted",
      title:
        "BIM 2021 (Springer, Paper ID: 1248) and IC4IR 2021(Paper ID: 407)",
      grade:
        "A Hybrid CNN-LSTM based Emotional Status Determination using Physiology Signals and Brain Tumor Classification using Transfer Learning from MRI Images",
      duration: "2022",
    },
  ];
  return (
    <Container maxW={"container.lg"}>
      <Head />
      <Education
        edu={edu}
        name="ACADEMIC CAREER"
        // title="Here is some info about my programming journey. how i became a web dev you can have some idea from below. information. please do click on the name of the institutions to reach their website."
      />
      <Education
        edu={awards}
        name="HONOR AND AWARD"
        // title="Here is some info about my Academic Carrier . from start to begin ."
      />
      <Education
        edu={courses}
        name="COURSES"
        // title="Here is some info about my Academic Carrier . from start to begin ."
      />

      <Education
        edu={exp}
        name="EXPERIENCES"
        // title="Here is some info about my experiences. i have no experiences working in any company as a web dev . but i have some other experiences which you can see below."
      />
    </Container>
  );
};

export default About;
